/* eslint-disable no-undef */
import React from 'react';
import { Box } from '@mui/material';
import ChatChannels from './ChatChannels';

export interface IChatSidebar {
  activeChat: string;
  loginUserProfileImage: string;
  loginUserFName: string;
  handleCreateGroup: () => void;
  handleCreateNewChat: () => void;
  chatType: string;
  setActiveChat: React.Dispatch<string>;
  filteredDirectMessages: IThread[];
  formattedAcsOrgUsers: IFormattedAcsOrgUser[];
  threadValue: string;
  commId: string;
  activeItemRef: React.MutableRefObject<any>;
  filterParticipantsFromDirectThreads: IChatThread[];
  groupMessages: IGroupMessage[];
  chatPopupClick: (event: any) => void;
  chatPopupClose: () => void;
  anchorEl: any;
  chatPopup: any;
  activeMessageId: any;
  loading?: boolean;
}

const ChatSideBar: React.FC<IChatSidebar> = ({
  activeChat,
  loginUserProfileImage,
  loginUserFName,
  handleCreateGroup,
  handleCreateNewChat,
  chatType,
  setActiveChat,
  filteredDirectMessages,
  formattedAcsOrgUsers,
  threadValue,
  commId,
  activeItemRef,
  filterParticipantsFromDirectThreads,
  groupMessages,
  chatPopupClick,
  chatPopupClose,
  anchorEl,
  chatPopup,
  activeMessageId,
  loading
}) => {
  return (
    <Box className="chat-v2__sidebar">
      <ChatChannels
        activeChat={activeChat}
        activeItemRef={activeItemRef}
        commId={commId}
        loading={loading}
        filterParticipantsFromDirectThreads={filterParticipantsFromDirectThreads}
        filteredDirectMessages={filteredDirectMessages}
        formattedAcsOrgUsers={formattedAcsOrgUsers}
        groupMessages={groupMessages}
        threadValue={threadValue}
        activeMessageId={activeMessageId}
        accessUserChatShow={false}
        onCreateGroup={handleCreateGroup}
        onCreateDirect={handleCreateNewChat}
      />
    </Box>
  );
};

export default ChatSideBar;
